










































































































































































































import {AccountTypeEnum, JunctionOperator, PartyModel, TenantModel, TenantUserModel} from '@/libs/Api';
import { partiesStore } from '@/libs/parties/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import PartyCreateDialog from '@/libs/parties/components/PartyCreateDialog.vue';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import { Constants } from '@/constants';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';
import { Filters, PageFilter } from '@/filters';
import {tenantsStore} from "@/libs/tenants/+state/store";

@Component({
    components: {
        PartyCreateDialog
    }
})
export default class Parties extends Page {

    pageInitialization = true;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "displayName" ];
    sortDesc = [ false ];
    
    @Prop() tenantId!: string;

    get tableHeaders() {
        return [
            { text: this.$i18n.t("clients.columnName"), value: "displayName", align: "left" },
            { text: this.$i18n.t("clients.columnDistrict"), value: "district.name", align: "left" },
            { text: this.$i18n.t("clients.columnTown"), value: "town.name", align: "left" },
            { text: this.$i18n.t("clients.columnAddress"), value: "address", align: "left" },
            { text: this.$i18n.t("clients.columnMainCareProvider"), value: "mainCareProvider.displayName", align: "left" },
            { text: this.$i18n.t("clients.columnPhoneNumber"), value: "phoneNumber", align: "left" },
            { text: "Příspěvek na péči", value: "careAllowence.allowenceValue", align: "left" },
            { text: this.$i18n.t("clients.columnState"), value: "clientState.name", align: "left" },
            { text: "", value: "id", align: "right" }
        ];
    }
    stateFilter: string | null = "";
    districtFilter: string | null = "";
    townFilter: string | null = "";
    userFilter: string | null = "";
    otherUserFilter: string | null = "";

    get constants(): Constants {
        return Constants;
    }

    get loading(): boolean {
        return partiesStore.useGetter(CrudGetter.Pending);
    }

    get items(): PartyModel[] {
        return [...partiesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        const stats = partiesStore.useGetter(CrudGetter.DataStats) as CrudDataStats;
        return stats?.rowCount ?? 0;
    }

    get exporting(): boolean {
        return partiesStore.useGetter(CrudGetter.Downloading);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    @Ref() dialog!: PartyCreateDialog;
    @Ref() exportDialog!: ExportDialog;

    @Watch("districtFilter")
    @Watch("townFilter")
    @Watch("stateFilter")
    @Watch("userFilter")
    @Watch("otherUserFilter")
    filtersChanged (v: any, p: any) {
        this.pageIndex = 1;
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    created () {
        if (this.getQuery("state") != null || this.getQuery("user") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQueryInt("pageSize") != null) {
            this.stateFilter = this.getQuery("state") ?? Constants.PartyStateActiveId;
            this.userFilter = this.getQuery("user") ?? "";
            this.otherUserFilter = this.getQuery("otherUser") ?? "";
            this.districtFilter = this.getQuery("district") ?? "";
            this.townFilter = this.getQuery("town") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            this.stateFilter = Filters.loadFilter('Parties', 'state') ?? Constants.PartyStateActiveId;
            this.userFilter = Filters.loadFilter('Parties', 'user') ?? null;
            this.otherUserFilter = Filters.loadFilter('Parties', 'otherUser') ?? null;
            this.districtFilter = Filters.loadFilter('Parties', 'district') ?? null;
            this.townFilter = Filters.loadFilter('Parties', 'town') ?? null;
            this.pageSize = Number(Filters.loadFilter('Parties', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    mounted () {
        this.loadItems();
    }

    saveQuery () {
        this.setQuery("state", this.stateFilter);
        this.setQuery("user", this.userFilter);
        this.setQuery("otherUser", this.otherUserFilter);
        this.setQuery("district", this.districtFilter);
        this.setQuery("town", this.townFilter);
        this.setQuery("pageSize", this.pageSize > 0 ? this.pageSize?.toString() : '25');
        const filters: PageFilter = {
            pageName: 'Parties',
            filters: [
                { name: 'state', value: this.stateFilter ?? Constants.PartyStateActiveId },
                { name: 'user', value: this.userFilter },
                { name: 'otherUser', value: this.otherUserFilter },
                { name: 'town', value: this.townFilter },
                { name: 'district', value: this.districtFilter },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
    }

    clearFilters () {
        this.stateFilter = Constants.PartyStateActiveId;
        this.userFilter = null;
        this.otherUserFilter = null;
        if (this.isAdmin) {
            this.districtFilter = null;
        }
        this.townFilter = null;
        this.saveQuery();
    }

    loadItems () {
        const filters = this.getFilters();
        let orderBy: CrudOrderBy<PartyModel>[] = [];
        if (this.sortBy.contains("displayName")) {
            orderBy = [
                { field: "lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
                { field: "firstName", index: 3, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
            ];
        }
        else if (this.sortBy.contains("mainCareProvider.displayName")) {
            orderBy = [
                { field: "mainCareProvider.firstName", index: 1, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
                { field: "mainCareProvider.lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
            ];
        }
        else if (this.sortBy && this.sortBy?.firstOrDefault()) {
            orderBy = [
                { field: this.sortBy?.first(), index: 2, order: this.sortDesc?.first() == true ? "desc" : "asc" }
            ];
        }
        else {
            orderBy = [
                { field: "lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
                { field: "firstName", index: 3, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
            ];
        }
        partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>(orderBy, filters, {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(partiesStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        })
    }

    getFilters() {

        let filters: CrudQueryPredicate[] = [];
        
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

        if (this.districtFilter && tenantUser.accountType == AccountTypeEnum.Admin)
            filters.push({ field: "districtId", op: "eq", comparand: this.districtFilter });
        
        if (this.townFilter)
            filters.push({ field: "townId", op: "eq", comparand: this.townFilter });
        
        if (this.stateFilter)
            filters.push({ field: "clientStateId", op: "eq", comparand: this.stateFilter });

		if (this.userFilter || this.otherUserFilter) {

			const userFilters: CrudQueryPredicate[] = [];

			if (this.userFilter)
				userFilters.push({ field: "mainCareProviderId", op: "eq", comparand: this.userFilter, junction: JunctionOperator.Or });

			if (this.otherUserFilter)
				userFilters.push({ field: "partyCareProviders.userId", op: "eq", comparand: this.otherUserFilter, junction: JunctionOperator.Or });

			filters.push({ field: "id", op: "wrap", comparand: userFilters });

		}

        const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
        if (tenantUser.accountType == AccountTypeEnum.Worker && !tenant.enableEditClientOfAnotherWorkers) {
			filters.push({ field: "partyCareProviders.userId", op: "eq", comparand: tenantUser.userId! });
		}

        return filters;

    }

    createItemClick () {
        this.dialog.open();
    }

    openItemClick (v: PartyModel) {
        this.dialog.open(v.id);
    }

    exportClick () {
        this.exportDialog.open();
    }

    exportDownload () {
        const filters = this.getFilters();
        partiesStore.dispatch(CrudAction.Download, createCrudQueryPayload<PartyModel>([
            { field: "lastName", index: 1, order: "asc" },
            { field: "firstName", index: 2, order: "asc" }
        ], filters));
        this.subscribe(partiesStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

}
